import createSpinner from "../../Shared/Functions/createSpinner";

export default /*@ngInject*/ function ($uibModalInstance, $http, helperService, isClone, selectedTemplateToClone, selectedTemplate, templateGridDataSource, ctProducts) {

    const vm = this;

    vm.template = {};
    vm.template.name = '';
    vm.selectedTemplateToClone = selectedTemplateToClone;
    vm.selectedTemplate = selectedTemplate;
    vm.gridDataSource = templateGridDataSource;
    vm.isClone = isClone;
    vm.addTemplate = addTemplate;
    vm.selectedProduct = null;
    vm.cancel = cancel;

    activate();

    async function activate() {
        vm.productsDataSource = ctProducts;
        if (isClone) {
            var product = ctProducts.find(p => p.ID === selectedTemplateToClone.ProductId);
            vm.selectedProduct = product;   
        }
        else {
            vm.selectedProduct = vm.productsDataSource[0];
        }
    }

    //Create or Clone a Template
    function addTemplate(e, templateName, selectedProduct) {
       vm.pleaseWait = new createSpinner();

        if (!isClone) {
            let input = { Name: templateName, ProductId: selectedProduct.ID, IsCustom: true };

            $http({
                method: 'POST',
                url: apiUrl + 'api/audittrail/template',
                data: input

            }).then(async function successCallback(response) {
                close(response.data);

            }, function errorCallback(response) {
                vm.pleaseWait.loadingValue = false;
                helperService.showErrorMessage(response.data);
            });
        } else {
            let input = vm.selectedTemplateToClone;

            if (input) {
                $http({
                    method: 'POST',
                    url: apiUrl + 'api/audittrail/template/' + input.Id + '/clone',
                    data: {
                        "TemplateId": input.Id,
                        "Name": vm.template.name
                    }
                }).then(async function successCallback(response) {
                    close(response.data);

                }, function errorCallback(response) {
                    vm.pleaseWait.loadingValue = false;
                    helperService.showErrorMessage(response.data);
                });
            }
        }
    }

    function cancel(value) {
        $uibModalInstance.close(value);
    }

    function close(createdId) {
        $uibModalInstance.close(createdId);
    }
}

